<template>
  <div v-if="base" class="base-information">
    <div class="info-item">
      <span>记分编号</span>
      <strong>{{ displayValue(base.scoring_num) }}</strong>
    </div>
    <div class="info-item">
      <span>姓名</span>
      <strong>{{ displayValue(base.name) }}</strong>
    </div>
    <div class="info-item">
      <span>性别</span>
      <strong>{{ genderText }}</strong>
    </div>
    <div class="info-item">
      <span>出生日期</span>
      <strong>{{ displayValue(base.born_date) }}</strong>
    </div>
    <div class="info-item">
      <span>测试年龄</span>
      <strong>{{ displayValue(base.real_age) }}</strong>
    </div>
    <div class="info-item">
      <span>测试日期</span>
      <strong>{{ displayValue(base.test_date) }}</strong>
    </div>
    <div class="info-item">
      <span>主试姓名</span>
      <strong>{{ displayValue(base.examiner_name) }}</strong>
    </div>
    <div class="info-item">
      <span>是否早产</span>
      <strong>{{ prematureText }}</strong>
    </div>
    <div v-if="base.is_premature_infant === '1'" class="info-item">
      <span>预产日期</span>
      <strong>{{ displayValue(base.expected_date) }}</strong>
    </div>
    <div v-if="base.is_premature_infant === '1'" class="info-item">
      <span>矫正后测试年龄</span>
      <strong>{{ displayValue(base.adjustment_age) }}</strong>
    </div>
    <div class="info-item">
      <span>照护者姓名</span>
      <strong>{{ displayValue(base.caregivers_name) }}</strong>
    </div>
    <div class="info-item">
      <span>与儿童关系</span>
      <strong>{{ relationshipText }}</strong>
    </div>
    <div class="info-item info-item-wide">
      <span>认知语言动作转介原因</span>
      <strong>{{ displayValue(base.referral_remark) }}</strong>
    </div>
    <div class="info-item info-item-wide">
      <span>社会情绪适应行为转介原因</span>
      <strong>{{ displayValue(base.so_referral_remark) }}</strong>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: Object,
  },
  computed: {
    base() {
      return this.data;
    },
    genderText() {
      if (String(this.base.gender) === '1') return '男';
      if (String(this.base.gender) === '2') return '女';
      return '—';
    },
    prematureText() {
      if (String(this.base.is_premature_infant) === '0') return '否';
      if (String(this.base.is_premature_infant) === '1') return '是';
      return '—';
    },
    relationshipText() {
      const relationships = {
        FATHER: '父亲',
        MONTHER: '母亲',
        GRAND_FATHER: '（外）祖父母',
      };
      if (this.base.relationship_of_child === 'OTHER') return this.displayValue(this.base.relationship_remark);
      return relationships[this.base.relationship_of_child] || '—';
    },
  },
  methods: {
    displayValue(value) {
      return value === null || value === undefined || value === '' ? '—' : value;
    },
  },
};
</script>

<style scoped>
.base-information {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #e6e1e4;
  border-radius: 6px;
  background: #e6e1e4;
  gap: 1px;
}

.info-item {
  min-width: 0;
  min-height: 74px;
  padding: 14px 16px;
  background: #fff;
}

.info-item span {
  display: block;
  margin-bottom: 7px;
  color: #8a848a;
  font-size: 12px;
}

.info-item strong {
  display: block;
  color: #3c373d;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.info-item-wide {
  grid-column: 1 / -1;
  min-height: 86px;
}

@media (max-width: 900px) {
  .base-information {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 520px) {
  .base-information {
    grid-template-columns: 1fr;
  }

  .info-item-wide {
    grid-column: auto;
  }
}
</style>
